import React, { useState } from "react";
import { Box, Drawer, useMediaQuery, useTheme } from "@mui/material";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";

const SIDEBAR_WIDTH = 260;

export default function Layout({ children }) {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => setMobileOpen((o) => !o);

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "background.default" }}>
      {/* Desktop sidebar */}
      {isDesktop && (
        <Box
          component="nav"
          sx={{
            width: SIDEBAR_WIDTH,
            flexShrink: 0,
            position: "fixed",
            top: 0,
            left: 0,
            bottom: 0,
            borderRight: 1,
            borderColor: "divider",
            bgcolor: "background.paper",
            zIndex: (t) => t.zIndex.drawer,
          }}
        >
          <Sidebar />
        </Box>
      )}

      {/* Mobile drawer */}
      {!isDesktop && (
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            "& .MuiDrawer-paper": { width: SIDEBAR_WIDTH, boxSizing: "border-box" },
          }}
        >
          <Sidebar onNavigate={() => setMobileOpen(false)} />
        </Drawer>
      )}

      {/* Main area */}
      <Box
        sx={{
          flexGrow: 1,
          minWidth: 0,
          ml: isDesktop ? `${SIDEBAR_WIDTH}px` : 0,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Header onMenuClick={handleDrawerToggle} />
        <Box component="main" sx={{ flexGrow: 1, p: { xs: 2, md: 3 } }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
}
